// extracted by mini-css-extract-plugin
export default {"modalEditedBlock":"ModalEditedBlock_modalEditedBlock__sqPgj","preview":"ModalEditedBlock_preview__NDiYD","overlay":"ModalEditedBlock_overlay__WB7hj"};